import getInstance from "../config/api";

export default class Distributor {
  static async fetchDistributors() {
    const instance = getInstance();
    const { data } = await instance.get("/distributor");
    return data;
  }

  static async activeDistributor(id) {
    const instance = getInstance();
    const { data } = await instance.put(`/distributor/active/${id}`);
    return data;
  }

  static async activeScoreDistributor(id) {
    const instance = getInstance();
    const { data } = await instance.put(`/distributor/activeScore/${id}`);
    return data;
  }

  static async activeCafDistributor(id) {
    const instance = getInstance();
    const { data } = await instance.put(`/distributor/activeCaf/${id}`);
    return data;
  }

  static async activeMicrocreditDistributor(id) {
    const instance = getInstance();
    const { data } = await instance.put(`/distributor/activeMicroCredit/${id}`);
    return data;
  }

  static async fetchDistributorById(id) {
    const instance = getInstance();
    const { data } = await instance.get(`/distributor/${id}`);
    return data;
  }

  static async activeInsuranceProposal(id) {
    const instance = getInstance();
    const { data } = await instance.put(
      `/distributor/activeInsuranceProposal/${id}`
    );
    return data;
  }
}
